import { render, staticRenderFns } from "./MarketExposureTable.vue?vue&type=template&id=65a08446&scoped=true&"
import script from "./MarketExposureTable.vue?vue&type=script&lang=js&"
export * from "./MarketExposureTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketExposureTable.vue?vue&type=style&index=0&id=65a08446&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a08446",
  null
  
)

export default component.exports